module.exports = __webpack_public_path__ + "img/dklb.6cce12a5.svg";